import Vue from 'vue';
import Vuex from 'vuex';

import async from './async';
import auth from './auth';
import views from './views';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    async,
    auth,
    views,
  },
});
